import { render, staticRenderFns } from "./make_video_detail_form.vue?vue&type=template&id=6ee2a73a"
import script from "./make_video_detail_form.vue?vue&type=script&lang=js"
export * from "./make_video_detail_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports